<div class="col-md-12 mb-3">
  <div class="border rounded p-2">
    <div class="d-flex justify-content-between align-items-center mb-2 row g-2">
      <div class="d-flex flex-row justify-content-between">
        <div class="d-flex flex-row align-items-baseline">
          <i [class]="config.iconClass"></i>
          <h4>{{ config.label }}</h4>
        </div>
        <a
          [routerLink]="[
            config.routePrefix,
            campaignData.campaignName +
              '_' +
              phase.phaseOrder +
              '_' +
              config.typeSuffix +
              '_' +
              nextChannelNumber,
          ]"
          [queryParams]="{
            campaignId: campaignData.campaignId,
            phaseId: phase.phaseId,
          }"
          class="no-underline text-success"
          target="_blank"
        >
          <i class="pi pi-plus-circle"></i> Create a new template and connect it
          automatically
        </a>
      </div>

      <p-autocomplete
        [(ngModel)]="selectedTemplate"
        [suggestions]="suggestions"
        (completeMethod)="searchTemplate($event)"
        (onSelect)="connectTemplateToPhase($event)"
        placeholder="Search and connect template to this phase"
        styleClass="w-100"
        [inputStyle]="{ width: '50%' }"
      />
    </div>

    <p-divider type="solid" />
    <h5>Connected templates</h5>
    <ul *ngIf="channels.length > 0" class="list-unstyled mb-0 mt-4">
      <li *ngFor="let channel of channels; let i = index" class="mb-1">
        <div class="d-flex justify-content-between align-items-center">
          <a
            [routerLink]="[config.routePrefix, channel.name]"
            class="text-decoration-none"
          >
            Template name: {{ channel.name }}
          </a>
          <button
            class="btn btn-sm btn-link text-danger p-0"
            (click)="
              removeTemplate.emit({
                phase: phase,
                channelId: channel.id,
                type: config.typeEnum,
              })
            "
          >
            <i class="pi pi-trash"></i>
          </button>
        </div>

        <div class="schedule-data">
          <div class="send-data">
            <p>
              Send date:
              <span [innerHTML]="parseDateFromName(channel.name)"></span>
            </p>
          </div>
          <div class="planned-data">
            <p>
              Planned date:
              <span
                ><p-datepicker
                  [ngModel]="channel.plannedDate"
                  [showIcon]="true"
                  [showOnFocus]="false"
                  [showButtonBar]="true"
                  (onSelect)="
                    plannedDateChange.emit({ channel: channel, event: $event })
                  "
                  (onClear)="
                    plannedDateChange.emit({ channel: channel, event: $event })
                  "
                  (onClearClick)="
                    plannedDateChange.emit({ channel: channel, event: $event })
                  "
                  inputId="buttondisplay"
              /></span>
            </p>
          </div>
        </div>

        <p-divider *ngIf="i !== channels.length - 1" type="solid" />
      </li>
    </ul>

    <div *ngIf="channels.length === 0" class="text-muted small">
      {{ config.emptyText }}
    </div>
  </div>
</div>
